// src/hooks/useApplyTxQueryParams.ts
import { useEffect } from 'react';

type TxType = 'income' | 'expense' | 'savings';
type Updater<T> = (prev: T) => T;

export function useApplyTxQueryParams<T extends Record<string, any>>(
  setFilters: (u: Updater<T>) => void,
  setShowFuture?: (v: boolean) => void,
  enabled: boolean = true
) {
  useEffect(() => {
    if (!enabled) return;

    const sp = new URLSearchParams(window.location.search);
    const type = sp.get('type') as TxType | null;
    const startDate = sp.get('startDate') || undefined;
    const endDate = sp.get('endDate') || undefined;
    const hasShowFuture = sp.has('showFuture');
    const showFuture = sp.get('showFuture') === 'true';

    if (type || startDate || endDate || hasShowFuture) {
      setFilters(prev => ({
        ...prev,
        ...(type ? { type } : {}),
        ...(startDate ? { startDate } : {}),
        ...(endDate ? { endDate } : {}),
      }));
      if (hasShowFuture && setShowFuture) setShowFuture(showFuture);
    }
  }, [setFilters, setShowFuture, enabled]);
}
